export enum ShapeErrorType {
  GRAPHQL,
  SHAPE_NOTFOUND
}
